import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  orders: null,
  orderCount: 0,
};

const orderHistorySlice = createSlice({
  name: "orderHistory",
  initialState,
  reducers: {
    fetchOrders(state, action) {
      state.loading = true;
    },
    fetchOrdersSuccess(state, action) {
      state.orders = action.payload.data.document;
      state.orderCount = action.payload.count;
      state.loading = false;
    },
    fetchOrdersFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = orderHistorySlice;
